import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

export function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);
  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);
  if (!offline) return null;
  return (
    <div className="fixed top-0 inset-x-0 z-[100] bg-neutral-900 text-white text-sm font-semibold px-4 py-2.5 pt-[calc(env(safe-area-inset-top)+0.6rem)] flex items-center justify-center gap-2" role="alert" data-testid="offline-banner">
      <WifiOff className="h-4 w-4 shrink-0" />You're offline. Changes can't be saved until you reconnect.
    </div>
  );
}
